export default __webpack_public_path__ + "static/media/QR.5789a7e0.jpeg";